import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import AccessDenied from './AccessDenied';

const ProtectedRoute = ({ children, requiredPermissions = [], fallbackPath = '/dashboard' }) => {
  const { user, loading: authLoading } = useAuth();
  const { hasPermission, loading: permissionsLoading } = usePermissions();

  if (authLoading || permissionsLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin users have access to everything
  if (user.role === 'ADMIN' || hasPermission('*')) {
    return children;
  }

  // Check if user has required permissions
  if (requiredPermissions.length > 0) {
    const hasRequiredPermission = requiredPermissions.some(permission => hasPermission(permission));

    if (!hasRequiredPermission) {
      return <AccessDenied message="You don't have permission to access this module. Please contact your administrator if you need access." />;
    }
  }

  return children;
};

export default ProtectedRoute;